import { useEffect } from 'react';
import { Layout7Root } from './Layout7Root';
import './styles.css';
import './services.css';
import { LayoutHeader as Header } from '@/layouts';
import { useTheme } from '@/contexts/ThemeContext';
import { LayoutFooter as Footer } from '@/layouts';
import { Button } from '@/components/ui/button';
import { useAppData } from '@/contexts/AppDataContext';
import { openWhatsApp } from '@/lib/whatsapp';
import { useStore } from '@/contexts/StoreContext';
import { MessageCircle } from 'lucide-react';
import { ServiceCard } from './ServiceCard';

const Services = () => {
  const { config } = useAppData();
  const { selectedStore } = useStore();
  const store = selectedStore || config.stores[0];
  const services = store.services || [];
  const { colors } = useTheme();
  const buttonColor = colors.button;
  const primaryColor = colors.primary;

  useEffect(() => {
    document.title = `Serviços - ${config.name}`;
  }, [config.name]);

  return (
    <Layout7Root withHeader className="wl7-services-page">
      <Header config={config} />

      <section className="wl7-section">
        <div className="wl7-container">
          <div className="wl7-section-header">
            <div>
              <p className="wl7-eyebrow">Serviços</p>
              <h1 className="wl7-h1 mt-1">Tudo para fechar negócio</h1>
              <p className="wl7-lead mt-1 max-w-lg text-sm">
                Financiamento, avaliação e muito mais em um só lugar.
              </p>
            </div>
          </div>

          {services.length === 0 ? (
            <div className="wl7-services-empty">
              <MessageCircle className="h-8 w-8 mx-auto mb-3 text-[var(--wl7-muted)] opacity-50" />
              <p className="font-semibold text-[var(--wl7-text)]">Nenhum serviço disponível no momento</p>
              <p className="text-sm text-[var(--wl7-muted)] mt-1">Entre em contato para saber como podemos ajudar.</p>
            </div>
          ) : (
            <div className="wl7-services-grid">
              {services.map((service: { service: string; image?: string }, index: number) => (
                <ServiceCard
                  key={`${service.service}-${index}`}
                  service={service}
                  config={config}
                />
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="wl7-section wl7-services-cta-section pt-0">
        <div className="wl7-container">
          <div className="wl7-cta" style={{ backgroundColor: primaryColor }}>
            <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-[var(--wl7-on-primary)]">
                  Precisa de ajuda com algum serviço?
                </h2>
                <p className="text-[var(--wl7-on-primary)] opacity-85 mt-2 max-w-md">
                  Fale com nossa equipe agora e receba atendimento personalizado.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 shrink-0">
                <Button
                  size="lg"
                  className="rounded-lg bg-white font-semibold h-12 px-6 hover:bg-white/90"
                  style={{ color: buttonColor }}
                  onClick={() => openWhatsApp(store.whatsapp?.ios)}
                >
                  <MessageCircle className="h-5 w-5 mr-2" />
                  WhatsApp
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="rounded-lg font-semibold h-12 px-6 border-white/30 text-white bg-white/10 hover:bg-white/20 hover:text-white"
                  onClick={() => { window.location.href = `tel:${store.phone?.formatted}`; }}
                >
                  Ligar agora
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer config={config} />
    </Layout7Root>
  );
};

export default Services;
